import { Spin } from 'antd'

const Spinner = ({ children, msg, loading, className }) => {
  return (
    <Spin className={className} tip={msg} spinning={loading} size={'large'}>{children}</Spin>
  )
}

export default Spinner